export const ContentForBackToSchoolCampaign = (fundraiserLink, fundraiserName, fundraisingGoal, fundraiserPageName) => {
return `I am excited to share that I am participating in TCF Canada’s Literacy Challenge! As part of the challenge, I will be spending six hours on Sunday, April 8th in the proverbial shoes of an illiterate person by giving up my ability to read or write – no texts, no social media, no email or even Google Maps!

I signed up for the challenge because literacy is a human right and TCF Canada is a the forefront of providing quality education for the underprivileged; being ranked a Top 10 Impact Charity by Charity Intelligence Canada for three years running. Over the course of 30 days, the campaign aims to raise ~$630,000, which is enough to educate ~3,500 children for a year!

Personally, I have committed to raising ${fundraisingGoal} as part of ${fundraiserPageName}. I hope you will consider making a donation and helping me spread the word about this Challenge!

Here is the link to the fundraising page: 

${fundraiserLink}


With gratitude,
${fundraiserName} `
}